import { Box } from '@mui/material';
import PageHeader from '../../components/PageHeader';
import React from 'react';
import MinimalFleetMap from '../../components/MinimalFleetMap';

const MapPage: React.FC = () => {
  console.log('🗺️ MapPage rendering MinimalFleetMap');
  return <Box><PageHeader title="Live Fleet Map" description="Track vehicle locations, connection status, and geofence zones in real time" icon="map" /><MinimalFleetMap /></Box>;
};

export default MapPage;